import connectQueryRules from "../connectors/connectQueryRules.js";
export default connectQueryRules(function QueryRuleContext() {
  return null;
}, {
  $$widgetType: 'ais.queryRuleContext'
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-core/dist/es/widgets/QueryRuleContext.js
// module id = 575
// module chunks = 1